import { render, staticRenderFns } from "./Rfq.vue?vue&type=template&id=794b7389&scoped=true"
import script from "./Rfq.vue?vue&type=script&lang=js"
export * from "./Rfq.vue?vue&type=script&lang=js"
import style0 from "./Rfq.vue?vue&type=style&index=0&id=794b7389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b7389",
  null
  
)

export default component.exports